export default __webpack_public_path__ + "static/media/f2.9e2496b7.jpg";